import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { Formik } from 'formik';
import AutoComplete from '../autocomplete/AutoComplete';
import Fieldset from '../fieldset/Fieldset';
import InputRange from '../input-range/InputRange';
import Input from '../input/Input';
import MultiSelect from '../multi-select/MultiSelect';
import PriceRange from '../price-range/PriceRange';
import Range from '../range/Range';
import Select from '../select/Select';
import SizeRange from '../size-range/SizeRange';
import TextArea from '../text-area/TextArea';
import * as styles from './Form.style';
import Actions from './actions/Actions';
import AutoCompleteV2Adapter from './autocomplete-v2-adapter/AutoCompleteV2Adapter';
import CheckboxAdapter from './checkbox-adapter/CheckboxAdapter';
import CheckboxButtonAdapter from './checkbox-button-adapter/CheckboxButtonAdapter';
import CheckboxToggleAdapter from './checkbox-toggle-adapter/CheckboxToggleAdapter';
import YesOrNotButtonsAdapter from './yes-or-not-buttons-adapter/YesOrNotButtonsAdapter';
import Confirm from './confirm/Confirm';
import ErrorMessage from './error-message/ErrorMessage';
import withField from './field/withField';
import Group from './group/Group';
import Item from './item/Item';
import RadioAdapter from './radio-adapter/RadioAdapter';
import RadioButtonAdapter from './radio-button-adapter/RadioButtonAdapter';
import RadioGroup from './radio-group/RadioGroup';
import Submit from './submit/Submit';
import SuccessMessage from './success-message/SuccessMessage';
import Title from './title/Title';
import RangeAdapter from './range-adapter/RangeAdapter';
import GenericFormContext from './FormContext';
import PriceField from '../price-field/PriceField';
import { DecimalPriceField } from '../decimal-price-field/DecimalPriceField';
export const Form = _ref => {
  let {
    enableReinitialize = false,
    preventEnterKeypress = false,
    disabled = false,
    loading = false,
    compact = false,
    initialValues,
    validationSchema,
    innerRef,
    dataRef,
    children,
    onSubmit,
    onSubmitErrors,
    ...rest
  } = _ref;
  const FormContext = GenericFormContext;
  const onKeyPress = React.useCallback(e => {
    const formTarget = e.target;
    if (preventEnterKeypress && e.key === 'Enter' && formTarget?.tagName !== 'TEXTAREA') {
      e.preventDefault();
      formTarget?.blur();
    }
  }, [preventEnterKeypress]);
  const computeContextValue = React.useCallback(formikProps => ({
    disabled,
    loading,
    compact,
    ...formikProps
  }), [compact, disabled, loading]);
  const onInternalSubmit = React.useCallback(formikProps => async e => {
    const {
      validateForm,
      handleSubmit
    } = formikProps;
    e.preventDefault();
    const validationErrors = await validateForm();
    if (onSubmitErrors && Object.keys(validationErrors).length > 0) {
      onSubmitErrors(validationErrors);
    }
    handleSubmit(e);
  }, [onSubmitErrors]);
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
    validateOnBlur: true,
    enableReinitialize: enableReinitialize,
    innerRef: innerRef
  }, formikProps => {
    const contextValue = computeContextValue(formikProps);
    return /*#__PURE__*/React.createElement(FormContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React.createElement("form", _extends({}, rest, {
      noValidate: true,
      "data-ref": dataRef,
      onSubmit: onInternalSubmit(formikProps),
      onKeyPress: onKeyPress
    }), /*#__PURE__*/React.createElement(_StyledDiv, {
      $compact: compact,
      $_css: styles.wrapper
    }, /*#__PURE__*/React.createElement(FormContext.Consumer, null, context => {
      if (typeof children === 'function') {
        return children(context);
      }
      return children;
    }))));
  });
};
Form.Title = Title;
Form.Item = Item;
Form.Group = Group;
Form.RadioGroup = RadioGroup;
Form.Fieldset = Fieldset;
Form.Input = withField(Input);
Form.PriceField = withField(PriceField);
Form.DecimalPriceField = withField(DecimalPriceField);
Form.InputRange = withField(InputRange);
Form.TextArea = withField(TextArea);
Form.Radio = withField(RadioAdapter);
Form.RadioButton = withField(RadioButtonAdapter);
Form.Checkbox = withField(CheckboxAdapter);
Form.CheckboxButton = withField(CheckboxButtonAdapter);
Form.CheckboxToggle = withField(CheckboxToggleAdapter);
Form.Select = withField(Select);
Form.AutoComplete = withField(AutoComplete);
Form.AutoCompleteV2 = withField(AutoCompleteV2Adapter);
Form.MultiSelect = withField(MultiSelect);
Form.Range = withField(RangeAdapter(Range));
Form.PriceRange = withField(RangeAdapter(PriceRange));
Form.SizeRange = withField(RangeAdapter(SizeRange));
Form.YesOrNotButtons = withField(YesOrNotButtonsAdapter);
Form.ErrorMessage = ErrorMessage;
Form.SuccessMessage = SuccessMessage;
Form.Actions = Actions;
Form.Confirm = Confirm;
Form.Submit = Submit;
Form.withField = withField;
export * from './Form.skeleton';
export * from './constants';
export * from './types';
export default Form;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Form___StyledDiv",
  componentId: "sc-ay45uz-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Form.js.map